export * from './baMenu.service';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/services/baMenu/index.ts